import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { BreadcrumbView, useRouteStack } from '../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../shared/icon/icon'
import { useParamsInt } from '../../../../shared/hooks/location'
import { useManageAssessmentForm } from '../../../../api/state'
import { Card } from '../../../../shared/card/card'
import { FormSimple } from '../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../shared/form-simple/form-hidden-number'
import { FormSimpleText } from '../../../../shared/form-simple/form-text'
import { FormSimpleSubmitCreate } from '../../../../shared/form-simple/form-submit'

export function AssessmentManageAdd() {
  const history = useHistory()

  const { nodeID } = useParamsInt()

  const [manageAssessmentFormActions] = useManageAssessmentForm()

  const { backRoute, getStackLevel } = useRouteStack()

  useEffect(() => {
    manageAssessmentFormActions.init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = async data => {
    let assessment = await manageAssessmentFormActions.post(data)
    let item = getStackLevel(1)
    history.replace(`${item.url}/edit/${assessment.id}`)
  }

  const handleCancel = () => backRoute(1)

  return (
    <React.Fragment>
      <BreadcrumbView icon={IconAdd} text="add">
        <Card title="Add Assessment">
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="nodeID" value={nodeID} />
            <FormSimpleText name="title" required autoFocus />
            <FormSimpleSubmitCreate onCancel={handleCancel} />
          </FormSimple>
        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
